import { render } from "./two-image-block.vue?vue&type=template&id=01bdb8f6"
import script from "./two-image-block.vue?vue&type=script&lang=js"
export * from "./two-image-block.vue?vue&type=script&lang=js"

import "./two-image-block.vue?vue&type=style&index=0&id=01bdb8f6&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__